import { render, staticRenderFns } from "./PublicTable1.vue?vue&type=template&id=2ce9d388&"
import script from "./PublicTable1.vue?vue&type=script&lang=ts&"
export * from "./PublicTable1.vue?vue&type=script&lang=ts&"
import style0 from "./PublicTable1.vue?vue&type=style&index=0&lang=scss&scpoed=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports